<div class="d-flex flex-row pb-3 mb-2" [class.mt-3]='!hasBreadcrumbs'>
    <div class="col">
        <div class="content-header d-flex justify-content-between">
            <div class="d-flex flex-row align-items-center">
                <fa-icon *ngIf='icon' [icon]='icon'></fa-icon>
                <p class="ms-2 title">{{title}}</p>
            </div>
        </div>
    </div>
    <div class="col" *ngIf="!registerPage" >
        <ng-content></ng-content>
    </div>
</div>
